export enum Role {
    User = 'User',
    Admin = 'FulfilmentAdmin',
    SuperAdmin = 'SuperAdmin'
}
